import createCompanyAnalysisTechnologiesService from "./factory";

const CompanyAnalysisTechnologiesService = createCompanyAnalysisTechnologiesService();

export default CompanyAnalysisTechnologiesService;
